"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialModule = void 0;
const router_1 = require("client/components/router");
const financials_view_1 = require("./modules/financials-view");
class FinancialModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("list", /^\/financials\/?$/, financials_view_1.FinancialsView);
    }
}
exports.FinancialModule = FinancialModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/financial/financials.tsx
// module id = 3445
// module chunks = 0